'use client'

import { useEffect, useState } from 'react'

export const useIsTablet = () => {
  const [isTablet, setIsTablet] = useState<boolean | null>(null)

  useEffect(() => {
    const mq = window.matchMedia('(min-width: 768px)')
    setIsTablet(mq.matches)

    const handler = (e: MediaQueryListEvent) => {
      setIsTablet(e.matches)
    }
    mq.addEventListener('change', handler)

    return () => {
      mq.removeEventListener('change', handler)
    }
  }, [])

  return isTablet
}
